export default __webpack_public_path__ + "static/media/calendar-accent.d3891747.svg";